import React, { createContext, useContext, useState } from 'react';
import Spinner from '../components/common/Spinner';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [loadingStates, setLoadingStates] = useState({});
    const [globalLoading, setGlobalLoading] = useState(false);

    const startLoading = (key = 'global') => {
        if (key === 'global') {
            setGlobalLoading(true);
        } else {
            setLoadingStates(prev => ({ ...prev, [key]: true }));
        }
    };

    const stopLoading = (key = 'global') => {
        if (key === 'global') {
            setGlobalLoading(false);
        } else {
            setLoadingStates(prev => ({ ...prev, [key]: false }));
        }
    };

    const isLoading = (key = 'global') => {
        return key === 'global' ? globalLoading : loadingStates[key];
    };

    return (
        <LoadingContext.Provider value={{ startLoading, stopLoading, isLoading }}>
            {globalLoading && (
                <div className="fixed inset-0 bg-gray-50 bg-opacity-75 flex justify-center items-center z-50">
                    <Spinner variant="dark" size="h-24 w-24" />
                </div>
            )}
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};
